import React from 'react';
import type { CampaignStatus } from '../../../models/MasterAdmin/pushNotificationCampaign';

const styles: Record<string, string> = {
  DRAFT: 'bg-gray-100 text-gray-700 dark:bg-gray-700/60 dark:text-gray-200',
  SCHEDULED: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100',
  SENDING: 'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-100',
  RUNNING: 'bg-blue-100 text-blue-900 dark:bg-blue-900/40 dark:text-blue-100',
  PAUSED: 'bg-orange-100 text-orange-900 dark:bg-orange-900/40 dark:text-orange-100',
  SENT: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-100',
  COMPLETED: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-100',
  CANCELLED: 'bg-slate-200 text-slate-700 dark:bg-slate-700/60 dark:text-slate-200',
  FAILED: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-100',
};

const labels: Record<string, string> = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  SENDING: 'Sending',
  RUNNING: 'Running',
  PAUSED: 'Paused',
  SENT: 'Sent',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  FAILED: 'Failed',
};

type Props = {
  status: CampaignStatus | string;
  className?: string;
};

const StatusBadge: React.FC<Props> = ({ status, className = '' }) => {
  const key = String(status || 'DRAFT').toUpperCase();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${styles[key] || styles.DRAFT} ${className}`}
    >
      {labels[key] || key}
    </span>
  );
};

export default StatusBadge;
